import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { DayHoursList, HourType } from "src/business/restaurant/restaurant";
import { InfoCard } from "src/design";
import { DayScheduleCard } from "./DayScheduleCard";

interface WeeklyScheduleSectionProps {
  schedule: DayHoursList;
  editing: boolean;
  onDayChange: (index: number, updated: HourType) => void;
}

export const WeeklyScheduleSection = ({
  schedule,
  editing,
  onDayChange,
}: WeeklyScheduleSectionProps) => {
  const { t } = useTranslation();

  const handleApplyToAll = (sourceIndex: number) => {
    const source = schedule[sourceIndex];
    schedule.forEach((dayHour, index) => {
      if (index !== sourceIndex) {
        onDayChange(index, {
          ...dayHour,
          morning: { ...source.morning },
          evening: source.evening ? { ...source.evening } : null,
        });
      }
    });
  };

  return (
    <Grid item>
      <InfoCard
        title={t("schedule.weeklySchedule")}
        subtitle={t("schedule.weeklyScheduleSub")}
      >
        {schedule.map((dayHour, index) => (
          <DayScheduleCard
            key={dayHour.day}
            dayHour={dayHour}
            editing={editing}
            onChange={(updated) => onDayChange(index, updated)}
            onApplyToAll={editing ? () => handleApplyToAll(index) : undefined}
          />
        ))}
      </InfoCard>
    </Grid>
  );
};
